<template>
  <v-autocomplete
    v-model="country"
    :items="countryOptions"
    :loading="isLoading"
    :search-input.sync="search"
    hide-no-data
    :hint="`${country.CnName}`"
            persistent-hint
    auto-select-first
    item-text="CntyName"
    item-value="CntyCode"
    :label="label"
    :prepend-icon="mdiDatabaseSearch"
    return-object no-filter
    :error-messages="errorMessages"
    @blur="onChange"
    :disabled="disabled"
    hide-details
    :inputmode="inputmode"
  ></v-autocomplete>
</template>

<script>
import {mdiDatabaseSearch} from "@mdi/js";
import debounce from 'lodash/debounce'
import isEmpty from 'lodash/isEmpty'
import { SelectCountry } from "@/api/publicServices";
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    cachedCountrys: {
      type: Array
    },
    errorMessages: {
      type:String
    },
    onChange: {
      type:Function
    },
    disabled:{
      type: Boolean
    }
  },
  data: () => ({
    countryOptions: [{
      CntyCode: 'HK',
      CntyName: 'HONG KONG',
      CnName: '香港',
      TelPrefix: '852'
    }],
    isLoading: false,
    search: null,
    country: {
      CntyCode: 'HK',
      CntyName: 'HONG KONG',
      CnName: '香港',
      TelPrefix: '852'
    },

    //svg icons
    mdiDatabaseSearch,
  }),

  computed: {
    inputmode() {
      return  localStorage.getItem("flutter") == "true" || this.$isMobile()?"none":"text";
    },
  },
  created: function() {
    this.debouncedSearchCountry = debounce(this.searchCountry, 500);
    this.debouncedFilterCachedCountry = debounce(this.filterCachedCountrys, 500);
  },
  methods: {
    async searchCountry(searchVal) {
      if (searchVal == null) return;
      if (this.isLoading) return;
      if (searchVal.length === 0) return;
      if (!isEmpty(this.country) && this.country.CntyName === searchVal) return;
      this.isLoading = true;
      try {
        const response = await SelectCountry({ "searchVal" :searchVal});
        this.isLoading = false;
        this.countryOptions = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    filterCachedCountrys(searchVal) {
      if (this.isLoading) return;
      if (searchVal.length === 0) return;
      const searchText = searchVal.toLowerCase();
      this.countryOptions = this.cachedCountrys.filter(country => {
        return country.CntyName.toLowerCase().indexOf(searchText) > -1;
      });
      this.isLoading = false;
    },
    async setCountry(Country) {
      await this.searchCountry(Country.CntyCode);
      console.log(Country)
      this.country.CntyCode = Country.CntyCode;
      this.country.CntyName = Country.CntyName;
      this.country.CnName = Country.CnName;
      this.country.TelPrefix = Country.TelPrefix;


      this.countryOptions =  [this.country];

    }
  },
  watch: {
    search(newVal) {
      if (this.cachedCountrys && this.cachedCountrys.length > 0) {
        this.debouncedFilterCachedCountry(newVal);
      } else {
        this.debouncedSearchCountry(newVal);
      }
    },
    country() {
      this.$emit("input", this.country);
    }
  }
};
</script>